import React, { Component } from "react"
import FocusLock from "react-focus-lock"

import { EndSimulation } from "./components/modals/endSimulation"

import { ProtocolOverview } from "./components/modals/protocolOverview"
import { ProtocolTable } from "./components/modals/protocolTable"

import { ThermocyclerPoster } from "./components/modals/thermocyclerPoster"
import { PowerSupplyControls } from "./components/modals/PowerSupplyControls"
import { GelPosition } from "./components/modals/GelPosition"
import { GelPipette } from "./components/modals/GelPipette"
import { TransilluminatorControls } from "./components/modals/TransilluminatorControls"
import { LabelTubes } from "./components/modals/LabelTubes"
import { AnimationSequence } from "./components/modals/animationSequence"
import { RecordAbsorbance } from "./components/modals/recordAbsorbance"
import { ExperimentalSetupPoster } from "./components/modals/experimentalSetupPoster"

// Animation dialogs

//import { PutOnPPE } from "./components/modals/PutOnPPE"
import { DepositSolution } from "./components/modals/depositSolution"
import { LoadGelBoxSolution } from "./components/modals/loadGelBoxSolution"
import { PrepareGelBox } from "./components/modals/prepareGelBox"
import { RunGelBox } from "./components/modals/runGelBox"
import { VisualiseGel } from "./components/modals/visualiseGel"

// import MicroCentrifugeBalancer from "components/modal/modals/microCentrifugeBalancer/MicroCentrifugeBalancer"
// import MicroCentrifugeControls from "components/modal/modals/microCentrifugeControls/microCentrifugeControls"
// import PowerSupplyControls from "components/modal/modals/powerSupplyControls/PowerSupplyControls"
// import GelPosition from "components/modal/modals/gelPosition/GelPosition"
import Undo from "./components/modals/undo/Undo"

import close from "./img/close.svg"
import "./style.scss";

export class Modal extends Component {
  constructor(props) {
    super(props);
    this.escFunction = this.escFunction.bind(this);
}

escFunction(event){
  if (event.key === "Escape") {
    //Do whatever when esc is pressed
    this.close()
  }
}
componentDidMount(){
  document.addEventListener("keydown", this.escFunction, false);
}
componentWillUnmount(){
  document.removeEventListener("keydown", this.escFunction, false);
}
  getContent = type => {
    switch (type) {
      case "PROTOCOL_READ":
        return <ProtocolOverview />;

      case "EXPERIMENTAL_SETUP_POSTER":
        return <ExperimentalSetupPoster altText={this.props.data.altText}/>;

      case "ABSORBANCE_TABLE":
        return <RecordAbsorbance id={this.props.connect} />;

      case "PROTOCOL_TABLE":
        return <ProtocolTable />;

      case "THERMOCYCLER_POSTER":
        return <ThermocyclerPoster />;

      case "POWERSUPPLY_CONTROLS":
        return <PowerSupplyControls id={this.props.connect} />;

      case "TRANSILLUMINATOR_CONTROLS":
        return <TransilluminatorControls id={this.props.connect} />;

      case "DEPOSIT_SOLUTION":
        return <DepositSolution />;

      case "LOAD_GELBOX_SOLUTION":
        return <LoadGelBoxSolution />;

      case "PREPARE_GELBOX":
        return <PrepareGelBox />;

      case "RUN_GELBOX":
        return <RunGelBox />;

      case "VISUALISE_GEL":
        return <VisualiseGel />;

      case "OVERNIGHT_WAIT":
        return <AnimationSequence
            id={this.props.connect}
            animation={this.props.data.animation}
            type={type}
            data={this.props.data}
            altText={this.props.data.altText}
         />;

     case "ROTATE_CUVETTE":
       return <AnimationSequence
           id={this.props.connect}
           animation={this.props.data.animation}
           type={type}
           data={this.props.data}
           altText={this.props.data.altText}
        />;

      case "HOLD_CUVETTE":
        return <AnimationSequence
            id={this.props.connect}
            animation={this.props.data.animation}
            type={type}
            data={this.props.data}
            altText={this.props.data.altText}
         />;

      case "GEL_POSITION":
        return <GelPosition id={this.props.connect}/>;

      case "GEL_PIPETTE":
        return (
          <GelPipette
            pipetteId={this.props.pipetteId}
            gelId={this.props.gelId}
            gelBoxId={this.props.gelBoxId}
          />
        );

      case "LABEL_TUBES":
        return <LabelTubes id={this.props.connect} />;

      case "PIPETTE_PLUNGER":
        return <AnimationSequence
                  id={this.props.connect}
                  animation={this.props.data.animation}
                  type={type}
               />;
      case "PUT_ON_PPE":
        return <AnimationSequence
                id={this.props.connect}
                animation={this.props.data.animation}
                type={type}
              />;
      // case "MICROCENTRIFUGE_BALANCER":
      //   return <MicroCentrifugeBalancer id={this.props.connect} />;
      //
      // case "MICROCENTRIFUGE_CONTROLS":
      //   return <MicroCentrifugeControls id={this.props.connect} />;
      //
      // case "POWERSUPPLY_CONTROLS":
      //   return <PowerSupplyControls id={this.props.connect} />;

      //
      case "UNDO":
        return <Undo />

      case "END_SIMULATION":
        return <EndSimulation />;

      default:
        return "No modal type matched";
    }
  };

  close = () => {
    this.props.showModal({ display: false });
  };

  applyFocusLock = (innerJSX) => {
    if(this.props.noteEntryOpen || ["Predictions","Results","Reflection"].includes(this.props.sectionSelected) ){
      //No focus lock if: notesEntry is open OR predictions, results, or reflection is open
      return innerJSX
    } else {
      return (
        <FocusLock>
          {innerJSX}
        </FocusLock>
      )
    }
  }

  render() {
    //passes inner into above func, wraps in focus lock if needed
    let inner = (
        <div
          className={"ProtocolModal " + ((this.props.size == "cover" && !this.props.notebookExpanded)?this.props.size + " full":this.props.size)}
          style={{ display: this.props.display ? "flex" : "none" }}
        >
          <div
            style={{
              display: "block"
            }}
          >
            <div className="wrapper">
              <div
                aria-label="Close Button"
                tabIndex={0}
                className={
                  this.props.type === "UNDO" &&
                  this.props.size === "sm"
                    ? "close-sm"
                    : "close"
                }

                onKeyDown={e => {
                  if (e.keyCode === 13 || e.keyCode === 32 || e.keyCode === 27) this.close(e);
                }}
                onClick={this.close}
              >
                <p>
                  Close{" "}
                  <img
                    style={{
                      display: "inline-block",
                      top: "3px",
                      position: "relative"
                    }}
                    src={close}
                    aria-label="Close button"
                  />
                </p>
              </div>
              {this.getContent(this.props.type)}
            </div>
          </div>
        </div>
    );

    return (this.applyFocusLock(inner))
  }
}
